import {  BaseTLTableComponent, AxiosResponse, NotificationSendService, NotificationSendFilter, BaseTLTableBase, tlISODateTimeToLocalNoSecondsString } from "../../../Infrastructure/CorBase/CoreBase";

export default abstract class NotificationViewListBase extends BaseTLTableComponent {

	protected selectedNotificationSendId: number = 0;

	protected notificationSendService: NotificationSendService = new NotificationSendService();

	protected callActionClick() {
		this.isBusy = true;
		this.notificationSendService.delete(this.itemsSelected).then(() => this.fetchData()).catch(error => {
			var errorMessage = this.$t('notificationSend.errorMessage').toString();
			super.showAlertModalWithErrorMessageList(errorMessage);
			this.isBusy = false;
		});
		this.itemsSelected = null;
		(this.$refs.notificationSendsTable as BaseTLTableBase).clearSelected();
	}

	public changeReadBase(itemsInput: any) {	
		var items = Array<number>();
		for (var i = 0; i < itemsInput.length; i++) {
			if (this.tableData.some(c => c.id == itemsInput[i] && c.isBold == true)) {
				items.push(itemsInput[i]);
			}
		}

		if (items.length > 0) {
			this.notificationSendService.readNotifications(items).then(res => {

				for (var i = 0; i < items.length; i++) {
					var item = this.tableData.find(c => c.id == items[i]);
					item.isBold = false;
					item.readDate = res.data;
					item.showOtherButton = false;
				}
				var countNewNotification = this.$store.state.notificationCount - items.length;
				this.$store.commit("notificationCount", countNewNotification);

				this.itemsSelected = null;
				if (this.selectItems.length > 0) {
					(this.$refs.notificationViewTable as BaseTLTableBase).clearSelected();
				}
				//	this.isBusy = false;
			}).catch((error) => {
				//	this.isBusy = false;
				super.showAlertModalWithErrorMessageList(error);
			});
		}
	}
	

	protected contentModal = this.$t('notificationSend.messageQuestionMain').toString();
	protected showAlertBeforeDeleteBase(itemsSelected: any) {
		
		var idNotificationSend = Number(itemsSelected);
		this.notificationSendService.getById(idNotificationSend).then(res => {
			var content = this.$t('notificationSend.messageQuestionMain').toString();
			if (res.data.corUserNotificationSendCount > 0) {
				content = this.$t('notificationSend.messageQuestionDelete1').toString() + res.data.corUserNotificationSendCount +
					this.$t('notificationSend.messageQuestionDelete2').toString() + content;
			}
			this.contentModal = content;
			this.showAlertBeforeActionClickBase(itemsSelected, content);
		});		
	}


	protected setFields() {
		this.fields = [
			//{ key: 'id', label: this.$t('notificationSend.fieldIdentif'), trans: 'notificationSend.fieldIdentif', sortable: true, class: 'text-center' },
			{ key: 'subject', label: this.$t('notificationSend.fieldSubject'), trans: 'notificationSend.fieldSubject', sortable: true, class: 'text-left ', design: 'isBold' },
  		{ key: 'sendPortalDate', label: this.$t('notificationSend.fieldDateIncome'), trans: 'notificationSend.fieldDateIncome', sortable: true, class: 'text-left',  sortDirection: 'asc',formatter: (x: Date) => tlISODateTimeToLocalNoSecondsString(x), design: 'isBold' },
			{ key: 'readDate', label: this.$t('notificationSend.fieldDateRead'), trans: 'notificationSend.fieldDateRead', sortable: true, class: 'text-left', formatter: (x: Date) => tlISODateTimeToLocalNoSecondsString(x), design: 'isBold' },
		
			{ key: 'actions', label: this.$t('notificationSend.fieldAction'), trans: 'notificationSend.fieldAction', class: 'text-right' }
		]
	};

	//TODO nefunguje filtr od do
	protected setfilters(value: any) {
		if (value != null) {
			this.filters = value;
		}
		else {
			this.filters = [
				{ key: 'subject', label: this.$t('notificationSend.fieldSubject'), trans: 'notificationSend.fieldSubject', selected: false, value: null, type: 'text' },
	
				{ key: 'sendDateFrom', label: this.$t('notificationSend.fieldDateIncomeFrom'), trans: 'notificationSend.fieldDateIncomeFrom', selected: false, value: null, type: 'datetime', moreThan: true, refItem: 'sendPortalDate' },
				{ key: 'sendDateTo', label: this.$t('notificationSend.fieldDateIncomeTo'), trans: 'notificationSend.fieldDateIncomeTo', selected: false, value: null, type: 'datetime', moreThan: false, refItem: 'sendPortalDate' },

		];
		}
	}



	protected fetchDataFromServer(): Promise<AxiosResponse<any>> {
		let notificationSendFilter: NotificationSendFilter = new NotificationSendFilter(this.$store.state.idPerson, this.$store.state.idTenant, null , true);
		return this.notificationSendService.getAllByFilter(notificationSendFilter);
	}

	//zat�m nepotrebujeme
	fetchRefreshDataFromServer(): Promise<AxiosResponse<any>> {
		return this.fetchDataFromServer();
	}

	refreshItems(items: any[], refreshData: any[]) {
		return items;
	}

	protected prepareItems(items: any[]) {
		for (var i = 0; i < items.length; i++) {
			items[i].sendDateFrom = items[i].sendPortalDate;
			items[i].sendDateTo = items[i].sendPortalDate;
		}}
};